import React, { useState, useEffect } from 'react'
import {Helmet} from "react-helmet";
import { Link } from 'react-router-dom'
import total from '../assets/about/total-logo.png'
import gordons from '../assets/about/gordons.png'
import fresh from '../assets/about/so-fresh.png'
import ekiti from '../assets/about/ekiti-logo.png'
import oldLagos from '../assets/about/old-lagos.png'
import temitope from '../assets/home/tpj4s.jpg'
import moment from '../assets/home/moment.jpg'
import hero from '../assets/home/hero.jpg'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import heroPrince from '../assets/home/portraits5.jpg'
import heroCouple from '../assets/home/wedding6.jpg'
import slide2 from '../assets/home/slide-2.jpg'
import slide3 from '../assets/home/slide-3.jpg'
import slide4 from '../assets/home/slide-4.jpg'
import slide5 from '../assets/home/slide-5.jpg'
import slide6 from '../assets/home/slide-6.jpg'
import slide7 from '../assets/home/slide-7.jpg'
import slide8 from '../assets/home/slide-8.jpg'
import slide9 from '../assets/home/slide-9.jpg'
import slide10 from '../assets/home/slide-10.jpg'
import slide11 from '../assets/home/slide-11.jpg'
import slide12 from '../assets/home/slide-12.jpg'
import slide13 from '../assets/home/slide-13.jpg'
import slide14 from '../assets/home/slide-14.jpg'
import slide15 from '../assets/home/slide-15.jpg'
import slide16 from '../assets/home/slide-16.jpg'
import slide17 from '../assets/home/slide-17.jpg'
import slide18 from '../assets/home/slide-18.jpg'
import slide20 from '../assets/home/slide-20.jpg'
import slide21 from '../assets/home/slide-21.jpg'
import logo from '../assets/components/logo-black.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import '../style.css'
import Testimonial from './components/Testimonial'


// ── FAQ DATA ──────────────────────────────────────────────
const faqs = [
	{
		q: "Do you travel outside of Manchester for commissions?",
		a: "Yes. While our operations are based in the UK, Glintz Media is an international brand. We frequently travel across the country and globally for destination weddings, documentaries, and commercial projects."
	},
	{
		q: "How would you describe your working style on set or at an event?",
		a: "Discreet and highly observant. We believe the best moments happen when you forget the camera is there. We provide gentle direction when necessary for portraits, but for many projects, we document reality as it naturally unfolds."
	},
	{
		q: "Do you provide both photography and cinematography?",
		a: "Yes. We have dedicated specialists for both media. This ensures a cohesive visual style across your still images and your final film, as our photo and video teams work seamlessly together under one creative direction."
	},
	{
		q: "What is the typical turnaround time for receiving a final gallery?",
		a: "We know you are eager to see your images. While turnaround times vary depending on the exact scope of the commission, we typically provide a curated preview within a few days of your event. Full wedding and event galleries are generally delivered within 4 to 6 weeks, while commercial project timelines are established during the initial consultation."
	},
	{
		q: "How far in advance should we book your services?",
		a: "For wedding and large-scale event photography, we recommend inquiring as early as possible, especially during the peak UK summer seasons. For commercial and portrait sessions, a 2 to 6-week notice is typically sufficient."
	},
	{
		q: "How will we receive our final images?",
		a: "We deliver your curated, high-resolution images through a secure private digital gallery. You can download your files directly and easily share the link with your team, family, or guests."
	},
];

// ── FAQ ACCORDION ─────────────────────────────────────────
const FAQItem = ({ faq, isOpen, onToggle }) => (
	<div className="border-b border-gray-200">
		<button
			className="w-full flex justify-between items-center py-5 text-left focus:outline-none"
			onClick={onToggle}
		>
			<span
				className="text-sm tracking-[.12em] uppercase text-custom-gray-head-text pr-4"
				style={{ fontFamily: "Muli" }}
			>
				{faq.q}
			</span>
			<span className="text-custom-gray-text text-xl flex-shrink-0">{isOpen ? "−" : "+"}</span>
		</button>
		<div
			className="overflow-hidden transition-all duration-300 ease-in-out"
			style={{ maxHeight: isOpen ? "400px" : "0px" }}
		>
			<p className="text-custom-gray-text text-sm leading-relaxed pb-5" style={{ fontFamily: "Muli" }}>
				{faq.a}
			</p>
		</div>
	</div>
);


const today = new Date().toISOString().split('T')[0];

// ── MAIN COMPONENT ────────────────────────────────────────
const HomePage = () => {
	const [setScrollPosition] = useState(0);
	const [posts, setPosts] = useState([]);
	const [openFaq, setOpenFaq] = useState(null);

	// Hero CTA form state
	const [heroFormData, setHeroFormData] = useState({
		role: '',
		firstName: '',
		lastName: '',
		email: '',
		instagram: '',
		phone: '',
		weddingDate: '',
		weddingLocation: '',
		aboutWedding: '',
		whyUs: '',
	});

	// Newsletter
	const [subscribeData, setSubscribeData] = useState({ email: '' });

	// Legacy homepage contact form
	// const [formData, setFormData] = useState({
	// 	fullName: '',
	// 	email: '',
	// 	subject: '',
	// 	message: '',
	// 	role: '',
	// 	firstName: '',
	// 	lastName: '',
	// 	instagram: '',
	// 	phone: '',
	// 	weddingDate: '',
	// 	weddingLocation: '',
	// 	aboutWedding: '',
	// 	whyUs: '',
	// });

	const schemaData = {
		"@context": "https://schema.org",
		"@type": "Organization",
		"name": "Glintz Studio",
		"url": "https://www.glintzphotography.org",
		"logo": "https://www.glintzphotography.org/logo.png",
		"sameAs": [
			"https://www.instagram.com/glintzweddingphotography",
			"https://web.facebook.com/glintzmedia",
		],
		"contactPoint": {
			"@type": "ContactPoint",
			"telephone": "+44-782-368-3844",
			"contactType": "Customer Support",
			"areaServed": ["GB", "NG"],
			"availableLanguage": ["English"]
		}
	};

	useEffect(() => {
		fetch('https://glintz-serverss.vercel.app/post').then(response => {
			response.json().then(posts => { setPosts(posts) })
		})
	}, []);

	const handleScroll = React.useCallback(() => {
		setScrollPosition(window.scrollY);
	}, [setScrollPosition]);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [handleScroll]);

	// Hover portfolio section
	useEffect(() => {
		const triggerElements = document.querySelectorAll('.hover-trigger');
		const imagePlaceholders = document.querySelectorAll('.image-placeholder');
		triggerElements.forEach((triggerElement, index) => {
			triggerElement.addEventListener('mouseenter', () => {
				imagePlaceholders.forEach((img, i) => {
					i === index ? img.classList.remove('hidden') : img.classList.add('hidden');
				});
			});
		});
	}, []);

	// ── FORM HANDLERS ─────────────────────────────────────
	// const handleInputChange = (e) => {
	// 	const { name, value } = e.target;
	// 	setFormData(prev => ({ ...prev, [name]: value }));
	// };

	const handleHeroInputChange = (e) => {
		const { name, value } = e.target;
		setHeroFormData(prev => ({ ...prev, [name]: value }));
	};

	const handleInputChangeSubscribe = (e) => {
		const { name, value } = e.target;
		setSubscribeData(prev => ({ ...prev, [name]: value }));
	};

	// Hero CTA form submission
	const heroContactForm = async (e) => {
		e.preventDefault();
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
				method: "POST",
				headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify(heroFormData),
			});
			const result = await response.json();
			if (result.success) {
				alert("Enquiry submitted! We will be in touch within 48 hours.");
				setHeroFormData({ role: '', firstName: '', lastName: '', email: '', instagram: '', phone: '', weddingDate: '', weddingLocation: '', aboutWedding: '', whyUs: '' });
			}
		} catch (error) {
			console.error("Error:", error);
			alert("There was an error submitting your form. Please try again.");
		}
	};

	// Legacy contact form
	// const contactForm = async (e) => {
	// 	e.preventDefault();
	// 	try {
	// 		const response = await fetch('https://glintz-serverss.vercel.app/contact', {
	// 			method: 'POST',
	// 			headers: { 'Content-Type': 'application/json' },
	// 			body: JSON.stringify(formData),
	// 		});
	// 		if (response.ok) {
	// 			alert('Form submitted successfully');
	// 			setFormData({ fullName: '', email: '', subject: '', message: '', role: '', firstName: '', lastName: '', instagram: '', phone: '', weddingDate: '', weddingLocation: '', aboutWedding: '', whyUs: '' });
	// 		}
	// 	} catch (error) { console.error('Error submitting form:', error); }
	// };

	const subscribeForm = async (e) => {
		e.preventDefault();
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/subscribe`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(subscribeData),
			});
			if (response.ok) {
				alert('You have successfully subscribed to our newsletter');
				setSubscribeData({ email: '' });
			}
		} catch (error) { console.error('Error submitting form:', error); }
	};

	const inputClass = `border-b border-gray-400 text-sm text-black w-full tracking-[.1em] focus:outline-none focus:border-black bg-transparent py-2 transition-colors duration-200`;
	const labelClass = `block text-xs tracking-[.2em] text-custom-gray-head-text mb-2`;

	return (
		<>
			<Helmet>
				<title>Glintz Photography | Professional Photography in Manchester & Across the UK</title>
				<meta name="description" content="Professional photography in Manchester & across the UK. Glintz Photography specialises in weddings, portraits, corporate events & documentary projects." />
				<script type="application/ld+json">{JSON.stringify(schemaData)}</script>
			</Helmet>
			<Navbar />

			{/* ── SECTION 1: HERO SLIDER ── */}
			<div className="h-screen pt-16 xl:pt-24 relative">
				<Swiper
					spaceBetween={30}
					centeredSlides={true}
					autoplay={{ delay: 2500, disableOnInteraction: false }}
					navigation={true}
					modules={[Autoplay, Pagination, Navigation]}
					className="mySwiper"
				>
					<SwiperSlide><img src={slide2} alt="Wedding reception dance, Nigerian wedding photography UK" /></SwiperSlide>
					<SwiperSlide><img src={slide3} alt="Pre-wedding photoshoot, beach, Nigerian wedding" /></SwiperSlide>
					<SwiperSlide><img src={slide4} alt="Pre-wedding photoshoot, bride and groom" /></SwiperSlide>
					<SwiperSlide><img src={slide5} alt="Concert, celebrity, performance photography" /></SwiperSlide>
					<SwiperSlide><img src={slide6} alt="Documentary, nature photography" /></SwiperSlide>
					<SwiperSlide><img src={slide7} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide8} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide9} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide10} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide11} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide12} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide13} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide14} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide15} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide16} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide17} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide18} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide20} alt="" /></SwiperSlide>
					<SwiperSlide><img src={slide21} alt="" /></SwiperSlide>
				</Swiper>

				{/* Hero overlay text + CTAs */}
				<div className="absolute inset-0 flex flex-col justify-end items-center pb-10 xl:pb-20 z-10 text-center px-4 xl:px-6 pointer-events-none"
					style={{ background: "linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 60%)" }}
				>
					<p className="text-white text-xs tracking-[.35em] uppercase mb-3 opacity-80" style={{ fontFamily: "Muli" }}>
						Manchester & Across the UK
					</p>
					<h1 className="text-white uppercase xl:text-5xl lg:text-4xl md:text-3xl text-2xl tracking-[.12em] leading-tight mb-3 max-w-4xl">
						Professional Photography in Manchester & Across the UK
					</h1>
					<p className="hidden sm:block text-white text-sm max-w-2xl mb-8 opacity-90 leading-relaxed" style={{ fontFamily: "Muli" }}>
						We capture life's most important moments, so they last a lifetime. From corporate campaigns to private celebrations, we deliver high-end photography deeply rooted in essence and emotion.
					</p>
					<div className="flex flex-wrap gap-4 justify-center pointer-events-auto">
						<a
							href="/contact"
							className="bg-white text-custom-gray-head-text px-10 py-3 text-xs tracking-[.25em] uppercase hover:bg-opacity-90 transition-all"
							style={{ fontFamily: "Muli" }}
						>
							Book Your UK Session
						</a>
						<a
							href="/portfolio"
							className="border border-white text-white px-10 py-3 text-xs tracking-[.25em] uppercase hover:bg-white hover:text-custom-gray-head-text transition-all"
							style={{ fontFamily: "Muli" }}
						>
							View Portfolio
						</a>
					</div>
				</div>
			</div>


			{/* ── SECTION 2: TRUST SIGNALS ── */}
			<div className="bg-custom-light-bg py-16 xl:px-40 lg:px-20 px-8 text-center">
				<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{ fontFamily: "Muli" }}>
					Trusted By
				</p>
				<h2 className="uppercase xl:text-3xl lg:text-2xl text-xl tracking-[.12em] text-custom-gray-head-text mb-4">
					Trusted by Leading Brands & UK Corporates
				</h2>
				<div className="w-10 h-px bg-gray-400 mx-auto mb-6" />
				<p className="text-custom-gray-text text-sm max-w-2xl mx-auto mb-12 leading-relaxed" style={{ fontFamily: "Muli" }}>
					We bring years of high-volume, premium photography experience to every set. Our portfolio includes collaborations with forward-thinking businesses and established corporate clients who demand excellence and reliability.
				</p>
				<div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2 gap-8 items-center justify-items-center xl:px-20">
					<img src={total} alt="Total" className="xl:w-3/6 lg:w-3/6 w-2/4 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
					<img src={gordons} alt="Gordons" className="xl:w-3/6 lg:w-3/6 w-2/4 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
					<img src={fresh} alt="So Fresh" className="xl:w-3/6 lg:w-3/6 w-2/4 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
					<img src={ekiti} alt="Ekiti State" className="xl:w-3/6 lg:w-3/6 w-2/4 grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
					<img src={oldLagos} alt="Old Lagos" className="grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
				</div>
			</div>


			{/* ── PORTFOLIO GRID ── */}
			<div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 md:gap-40 sm:gap-20 gap-20
				xl:px-[200px] lg:px-[150px] md:px-[50px] sm:px-[100px] px-[50px] py-24 bg-white">
				<div>
					<h2 className="xl:text-[3.5em] lg:text-[3.5em] md:text-[3.5em] text-3xl uppercase tracking-[.15em] text-custom-gray-head-text">signature</h2>
					<p className="italic xl:text-2xl lg:text-2xl md:text-2xl text-xl w-4/5 mb-10 text-custom-gray-text">our style is clean, simple, and sincere to communicate essence</p>
					<div className="xl:h-[700px] lg:h-[500px] md:h-[500px] sm:h-[600px] h-[400px]" style={{ overflow: "hidden", cursor: "pointer" }}>
						<a href="/portfolio/wedding" style={{ display: 'block', height: '100%', width: '100%', overflow: 'hidden' }}>
							<div style={{ backgroundImage: `url(${heroCouple})`, backgroundSize: "cover", backgroundPosition: "center", height: "100%", width: "100%", transition: "transform 0.3s" }}
								onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
								onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
						</a>
					</div>
					<p className="uppercase text-sm tracking-[.15em] text-custom-gray-text mt-8">pre wedding</p>
					<h3 className="uppercase xl:text-2xl lg:text-2xl md:text-2xl text-xl text-custom-gray-head-text tracking-[.15em] mb-10 xl:mb-0 lg:mb-0 md:mb-0">bridal bouquet</h3>
				</div>
				<div>
					<div className="xl:h-[700px] lg:h-[500px] md:h-[500px] sm:h-[600px] h-[400px]" style={{ overflow: "hidden", cursor: "pointer" }}>
						<a href="/portfolio/wedding" style={{ display: 'block', height: '100%', width: '100%', overflow: 'hidden' }}>
							<div style={{ backgroundImage: 'url(https://res.cloudinary.com/dfs540rt8/image/upload/v1692952613/portraits7_tv8kba.jpg)', backgroundSize: "cover", backgroundPosition: "center", height: "100%", width: "100%", transition: "transform 0.3s" }}
								onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
								onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
						</a>
					</div>
					<p className="uppercase text-sm tracking-[.15em] text-custom-gray-text mt-8">traditional wedding</p>
					<h3 className="uppercase xl:text-2xl lg:text-2xl md:text-2xl text-xl text-custom-gray-head-text tracking-[.15em]">love and culture</h3>
				</div>
			</div>

			<div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1
				xl:px-[200px] lg:px-[150px] md:px-[50px] sm:px-[100px] px-[50px] gap-24 mb-20">
				<div>
					<div className="xl:h-[700px] lg:h-[500px] md:h-[500px] sm:h-[600px] h-[400px]" style={{ overflow: "hidden", cursor: "pointer" }}>
						<a href="/portfolio/portrait" style={{ display: 'block', height: '100%', width: '100%', overflow: 'hidden' }}>
							<div style={{ backgroundImage: `url(${heroPrince})`, backgroundSize: "cover", backgroundPosition: "center", height: "100%", width: "100%", transition: "transform 0.3s" }}
								onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
								onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
						</a>
					</div>
					<p className="uppercase text-sm tracking-[.15em] text-custom-gray-text mt-8">portrait</p>
					<h3 className="uppercase xl:text-2xl lg:text-2xl md:text-2xl text-xl text-custom-gray-head-text tracking-[.15em]">royal prince</h3>
				</div>
				<div className="xl:-mt-[200px] lg:-mt-[200px] md:-mt-64">
					<div className="xl:h-[700px] lg:h-[600px] md:h-[500px] sm:h-[600px] h-[400px]" style={{ overflow: "hidden", cursor: "pointer" }}>
						<a href="/portfolio/portrait" style={{ display: 'block', height: '100%', width: '100%', overflow: 'hidden' }}>
							<div style={{ backgroundImage: `url(${hero})`, backgroundSize: "cover", backgroundPosition: "center", height: "100%", width: "100%", transition: "transform 0.3s" }}
								onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
								onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
						</a>
					</div>
					<p className="uppercase text-sm tracking-[.15em] text-custom-gray-text mt-8">portrait</p>
					<h3 className="uppercase xl:text-2xl lg:text-2xl md:text-2xl text-xl text-custom-gray-head-text tracking-[.15em]">album cover</h3>
				</div>
			</div>


			{/* ── SECTION 3: PHILOSOPHY ── */}
			<div className="bg-custom-dark-gray-bg xl:px-40 lg:px-20 px-8 py-20 text-center">
				<p className="text-gray-400 text-xs tracking-[.35em] uppercase mb-5" style={{ fontFamily: "Muli" }}>
					Our Philosophy
				</p>
				<h2 className="uppercase xl:text-4xl lg:text-3xl text-2xl tracking-[.12em] text-white mb-6 max-w-3xl mx-auto leading-snug">
					Making a moment last a lifetime
				</h2>
				<div className="w-10 h-px bg-gray-500 mx-auto mb-8" />
				<p className="text-gray-300 max-w-3xl mx-auto text-sm leading-relaxed" style={{ fontFamily: "Muli" }}>
					Real life doesn't happen in stiff, forced poses. We do things differently. Whether we are documenting a corporate milestone in Greater Manchester or a quiet exchange at a countryside wedding, we get out of the way. We observe the subtle shifts in energy. We anticipate the unscripted chaos. You live the moment. We preserve the proof. The result is a timeless visual record you can actually trust.
				</p>
			</div>


			{/* ── VIDEO EMBED ── */}
			<div className="bg-custom-light-bg py-16 xl:px-40 lg:px-20 md:px-10 px-4">
				<iframe
					className="w-full xl:h-[700px] lg:h-[600px] md:h-[500px] h-[280px]"
					src="https://www.youtube.com/embed/HXtEqpiU5rY?si=qLP3hUKGScY7JhIC"
					title="Glintz Photography Showreel"
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					referrerPolicy="strict-origin-when-cross-origin"
					allowFullScreen
				/>
			</div>


			{/* ── SECTION 4: SERVICES ── */}
			<div className="xl:px-40 lg:px-20 px-8 py-20 bg-white">
				<div className="text-center mb-14">
					<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{ fontFamily: "Muli" }}>What We Do</p>
					<h2 className="uppercase xl:text-4xl lg:text-3xl text-2xl tracking-[.12em] text-custom-gray-head-text mb-4">
						Our UK Photography Services
					</h2>
					<div className="w-10 h-px bg-gray-400 mx-auto" />
				</div>

				<div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
					{[
						{
							title: "Portrait Photography in Manchester",
							href: "/portfolio/portrait",
							img: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952729/portraits2_chzkjm.jpg",
							desc: "Professional headshots, creative branding sessions, and editorial portraits. We create a relaxed environment, so your true personality comes through effortlessly on camera."
						},
						{
							title: "UK Wedding Photography",
							href: "/portfolio/wedding",
							img: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952817/wedding4_mp1g9o.jpg",
							desc: "Your wedding day is a fast-paced, emotional narrative. We blend into the background to document the genuine joy, tears, and celebrations, delivering a curated gallery you will look back on for decades."
						},
						{
							title: "Corporate & Private Events",
							href: "/portfolio/events",
							img: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952668/event1_bbohgl.jpg",
							desc: "From industry conferences and brand activations to private galas. We capture both the grand scale of your venue and the intimate networking interactions of your guests with minimal disruption."
						},
						{
							title: "Documentary Photography",
							href: "/portfolio/documentary",
							img: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952709/documentary_ncypzu.jpg",
							desc: "Visual essays and photojournalism designed to tell a deeper story. We embed ourselves in your project, cause, or community to produce compelling, truthful imagery that speaks volumes."
						},
						{
							title: "Commercial & Brand Photography",
							href: "/portfolio/commercial",
							img: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952714/video_nsw9xp.jpg",
							desc: "High-impact visual assets tailored for UK businesses. We shoot campaigns, product lines, and lifestyle content engineered to align perfectly with your marketing goals and drive customer engagement."
						},
					].map((service, i) => (
						<a key={i} href={service.href} className="group block">
							<div className="overflow-hidden mb-5">
								<img
									src={service.img}
									alt={service.title}
									className="w-full object-cover xl:h-64 h-52 transition duration-500 ease-in-out group-hover:scale-105"
								/>
							</div>
							<h3 className="uppercase text-sm tracking-[.15em] text-custom-gray-head-text mb-3" style={{ fontFamily: "Muli" }}>
								{service.title}
							</h3>
							<p className="text-custom-gray-text text-xs leading-relaxed mb-3" style={{ fontFamily: "Muli" }}>{service.desc}</p>
							<span className="text-xs tracking-[.2em] uppercase text-custom-gray-text border-b border-gray-300 pb-0.5 hover:border-gray-600 transition-colors" style={{ fontFamily: "Muli" }}>
								View Work →
							</span>
						</a>
					))}
				</div>
			</div>


			{/* ── CREATIVE DIRECTOR ── */}
			<div className="xl:px-80 xl:py-20 py-10 px-10">
				<div className="xl:py-14 py-10 text-center">
					<h2 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl uppercase text-custom-gray-head-text tracking-[.1em]">The Creative Director</h2>
				</div>
				<div className="flex justify-center w-full">
					<div className="grid grid-cols-1 gap-10 w-full max-w-7xl">
						<div className="text-custom-gray-text grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-10 items-center">
							<div><img src={temitope} alt="Temitope Jalekun - Creative Director, Glintz Media UK" className="w-full object-cover" /></div>
							<div className="flex flex-col xl:text-left lg:text-left md:text-left text-center xl:pl-10 lg:pl-10">
								<p className="text-md mb-2">Temitope Jalekun is a dynamic Wedding and Portrait photographer, an educator and creative director based in the United Kingdom. With over a decade experience, documenting love stories, families, and creating compelling commercial imagery for the brands such as Stanbic IBTC Bank, Haier Thermocool, PENCOM, Ekiti State Government Nigeria and many more. His works have been featured on CNN, Bellanaija, LoveweddingsNg, and Big Brother Nigeria.</p>
								<p className="text-md mb-2">TPJ also teaches and mentors photographers at The Creative Quarters Africa, a community designed to empower African creatives through Education, Access to tools and resources. He is also the host of TCQ podcast.</p>
								<p className="text-md mb-2">Temitope is a member of the British Institute of Professional Photography.</p>
							</div>
						</div>
					</div>
				</div>
			</div>


			{/* ── HOVER PORTFOLIO NAV ── */}
			<div className="xl:flex lg:flex md:flex grid grid-cols-1 xl:pl-10">
				<div className="my-auto order-2 xl:order-1 lg:order-1 md:order-1 px-10 xl:px-20 lg:px-0 md:px-0">
					<ul className="uppercase text-custom-gray-text tracking-[.15em] xl:text-4xl lg:text-4xl md:text-4xl text-2xl">
						<li className="py-4 hover:underline"><a href="/portfolio/portrait" className="hover-trigger" data-target="portrait">portrait</a></li>
						<li className="py-4 hover:underline"><a href="/portfolio/wedding" className="hover-trigger" data-target="wedding">wedding</a></li>
						<li className="py-4 hover:underline"><a href="/portfolio/events" className="hover-trigger" data-target="events">events</a></li>
						<li className="py-4 hover:underline"><a href="/portfolio/documentary" className="hover-trigger" data-target="documentary">documentary</a></li>
						<li className="py-4 hover:underline"><a href="/portfolio/commercial" className="hover-trigger" data-target="commercial">commercial</a></li>
					</ul>
				</div>
				<div className="order-1 xl:order-2 lg:order-2 md:order-2 px-10 xl:px-0 lg:px-0 md:px-0">
					<img src="https://res.cloudinary.com/dfs540rt8/image/upload/v1692952714/video_nsw9xp.jpg" alt="portrait" className="image-placeholder" data-target="portrait" />
					<img src="https://res.cloudinary.com/dfs540rt8/image/upload/v1692952817/wedding4_mp1g9o.jpg" alt="wedding" className="hidden image-placeholder" data-target="wedding" />
					<img src="https://res.cloudinary.com/dfs540rt8/image/upload/v1692952668/event1_bbohgl.jpg" alt="events" className="hidden image-placeholder" data-target="events" />
					<img src="https://res.cloudinary.com/dfs540rt8/image/upload/v1692952709/documentary_ncypzu.jpg" alt="documentary" className="hidden image-placeholder" data-target="documentary" />
					<img src="https://res.cloudinary.com/dfs540rt8/image/upload/v1692952668/event1_bbohgl.jpg" alt="commercial" className="hidden image-placeholder" data-target="commercial" />
				</div>
			</div>


			{/* ── SECTION 5: WHY CHOOSE US ── */}
			<div className="bg-custom-light-bg xl:px-40 lg:px-20 px-8 py-20">
				<div className="text-center mb-14">
					<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{ fontFamily: "Muli" }}>Our Commitment</p>
					<h2 className="uppercase xl:text-4xl lg:text-3xl text-2xl tracking-[.12em] text-custom-gray-head-text mb-4">
						Why Choose Glintz Photography?
					</h2>
					<div className="w-10 h-px bg-gray-400 mx-auto mb-6" />
					<p className="text-custom-gray-text text-sm max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "Muli" }}>
						Our expansion into the UK market brings years of high-volume, premium photography experience to Manchester. We guarantee a satisfactory client experience from the first inquiry to the final gallery delivery.
					</p>
				</div>
				<div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-1 grid-cols-1 gap-8 max-w-5xl mx-auto">
					{[
						{
							icon: "https://img.icons8.com/ios/44/000000/clock--v1.png",
							title: "Fast Turnaround",
							desc: "We know you want your photos quickly. We guarantee clear timelines and stick to them."
						},
						{
							icon: "https://img.icons8.com/ios/44/000000/security-checked.png",
							title: "Fully Compliant",
							desc: "We operate with complete adherence to UK data protection (GDPR), ensuring your privacy and image rights are secure."
						},
						{
							icon: "https://img.icons8.com/ios/44/000000/price-tag-pound.png",
							title: "Transparent UK Pricing",
							desc: "No hidden fees. All quotes are provided in GBP with clear, itemised deliverables."
						},
					].map((item, i) => (
						<div key={i} className="bg-white p-10 text-center">
							<div className="flex justify-center mb-5">
								<img width="36" height="36" src={item.icon} alt={item.title} />
							</div>
							<h3 className="uppercase text-sm tracking-[.2em] text-custom-gray-head-text mb-3" style={{ fontFamily: "Muli" }}>{item.title}</h3>
							<p className="text-custom-gray-text text-xs leading-relaxed" style={{ fontFamily: "Muli" }}>{item.desc}</p>
						</div>
					))}
				</div>
			</div>


			{/* ── SECTION 6: BLOG ── */}
			<div className="xl:px-40 lg:px-20 px-10 py-20 bg-white">
				<div className="text-center mb-12">
					<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{ fontFamily: "Muli" }}>Insights & Guides</p>
					<h2 className="text-custom-gray-head-text xl:text-4xl lg:text-4xl md:text-3xl text-2xl tracking-[.15em] uppercase mb-4">
						Expert Guides for Planning Your Next Shoot
					</h2>
					<div className="w-10 h-px bg-gray-400 mx-auto mb-6" />
					<p className="text-custom-gray-text italic text-sm max-w-xl mx-auto" style={{ fontFamily: "Muli" }}>
						Explore our latest articles on leveraging commercial photography for business growth, preparing for your sessions, and selecting the right venues across the UK.
					</p>
				</div>
				<div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 gap-8">
					{posts.length > 0 && posts.slice(0, 3).map((post, i) => (
						<div key={i}>
							<Link to={`/blog/${post.slug}`}>
								<div className="overflow-hidden">
									<img src={post.cover} alt={post.title} className="w-full transition duration-500 hover:scale-105" />
								</div>
							</Link>
							<h3 className="uppercase tracking-[.12em] text-custom-gray-head-text text-base font-semibold py-3" style={{ fontFamily: "Muli" }}>{post.title}</h3>
							<Link to={`/blog/${post.slug}`}>
								<button className="py-1 mt-1 uppercase tracking-[.25em] border-none text-xs text-custom-gray-text hover:underline" style={{ fontFamily: "Muli" }}>
									read more →
								</button>
							</Link>
						</div>
					))}
				</div>
				<div className="text-center mt-12">
					<Link to="/blog">
						<button className="border border-custom-gray-head-text px-12 py-3 text-xs tracking-[.25em] uppercase text-custom-gray-head-text hover:bg-custom-gray-head-text hover:text-white transition-all" style={{ fontFamily: "Muli" }}>
							Read All Articles
						</button>
					</Link>
				</div>
			</div>


			{/* ── LET'S DOCUMENT SECTION ── */}
			<div className="xl:h-screen lg:h-[600px] md:h-[500px] h-[350px] flex justify-center items-center relative"
				style={{ backgroundImage: `url(${moment})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: 'center center' }}
			>
				<div className="absolute inset-0 bg-black bg-opacity-30" />
				<h2 className="relative z-10 text-white xl:text-4xl lg:text-4xl md:text-3xl text-xl uppercase tracking-[.25em] text-center px-6">
					let's document these moments together!
				</h2>
			</div>


			{/* ── TESTIMONIALS ── */}
			<div className="py-16 bg-white">
				<Testimonial />
			</div>


			{/* ── MEMORY GRID ── */}
			<div className="grid grid-cols-2 xl:grid-cols-4 md:grid-cols-2">
				{[
					{ src: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952729/portraits2_chzkjm.jpg", label: "capture moment" },
					{ src: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952730/portraits3_pcvv3m.jpg", label: "now and forever" },
					{ src: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952613/portraits7_tv8kba.jpg", label: "let's celebrate" },
					{ src: "https://res.cloudinary.com/dfs540rt8/image/upload/v1692952710/portraits6_lr6mal.jpg", label: "birthday portrait" },
				].map((item, i) => (
					<div key={i} className="relative group h-[250px] md:h-[350px] xl:h-[500px] overflow-hidden">
						<img src={item.src} alt={item.label} className="w-full h-full object-cover transition duration-300 ease-in-out transform group-hover:scale-105" />
						<div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-50 transition duration-300 ease-in-out" />
						<div className="absolute bottom-0 left-0 w-full px-4 py-4 border-b border-white translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out">
							<p className="text-white text-xs uppercase tracking-[.15em]" style={{ fontFamily: "Muli" }}>memory</p>
							<p className="text-base text-white uppercase tracking-[.08em]">{item.label}</p>
						</div>
					</div>
				))}
			</div>


			{/* ── SECTION 7: CTA CONTACT FORM ── */}
			<div className="pb-20 xl:pt-24 lg:pt-24 md:pt-20 pt-16 bg-custom-light-bg" style={{ backgroundImage: "url(https://solene.qodeinteractive.com/wp-content/uploads/2019/12/contact-2-bckgr-img.png)" }}>
				<div className="bg-white xl:mx-80 lg:mx-20 mx-5 xl:px-[10%] lg:px-20 md:px-12 px-6 py-16">
					<div className="text-center mb-12">
						<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{ fontFamily: "Muli" }}>Get In Touch</p>
						<h2 className="xl:text-3xl lg:text-3xl md:text-2xl text-2xl tracking-[.2em] uppercase text-custom-gray-head-text mb-4">
							Begin Your Photography Project
						</h2>
						<div className="w-10 h-px bg-gray-400 mx-auto mb-5" />
						<p className="text-custom-gray-text text-sm max-w-xl mx-auto leading-relaxed" style={{ fontFamily: "Muli" }}>
							Fill out the form below to discuss your photography needs, check our UK availability, and receive a clear, itemized quote.
						</p>
					</div>

					<form onSubmit={heroContactForm}>
						<div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-x-8 gap-y-8">
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>ROLE *</label>
								<select className={inputClass} name="role" value={heroFormData.role} onChange={handleHeroInputChange} style={{ fontFamily: "Muli" }} required>
									<option value="">Select</option>
									<option value="bride">Bride</option>
									<option value="groom">Groom</option>
									<option value="couple">Couple</option>
									<option value="event-planner">Event Planner</option>
									<option value="corporate">Corporate</option>
									<option value="other">Other</option>
								</select>
							</div>
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>FIRST NAME *</label>
								<input className={inputClass} type="text" name="firstName" value={heroFormData.firstName} onChange={handleHeroInputChange} style={{ fontFamily: "Muli" }} required />
							</div>
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>LAST NAME *</label>
								<input className={inputClass} type="text" name="lastName" value={heroFormData.lastName} onChange={handleHeroInputChange} style={{ fontFamily: "Muli" }} required />
							</div>
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>EMAIL ADDRESS *</label>
								<input className={inputClass} type="email" name="email" value={heroFormData.email} onChange={handleHeroInputChange} style={{ fontFamily: "Muli" }} required />
								{heroFormData.email.length > 0 && !/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/.test(heroFormData.email) && (
									<span className="text-red-500 text-xs mt-1 block" style={{ fontFamily: "Muli" }}>Invalid email format</span>
								)}
							</div>
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>INSTAGRAM HANDLE <span className="opacity-50">(OPTIONAL)</span></label>
								<input className={inputClass} type="text" name="instagram" value={heroFormData.instagram} onChange={handleHeroInputChange} placeholder="@yourhandle" style={{ fontFamily: "Muli" }} />
							</div>
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>UK PHONE NUMBER (+44) *</label>
								<input className={inputClass} type="tel" name="phone" value={heroFormData.phone} onChange={handleHeroInputChange} placeholder="+44" style={{ fontFamily: "Muli" }} required />
							</div>
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>WEDDING / EVENT DATE *</label>
								<input className={inputClass} type="date" name="weddingDate" value={heroFormData.weddingDate} onChange={handleHeroInputChange} min={today} style={{ fontFamily: "Muli", colorScheme: "light" }} required />
							</div>
							<div>
								<label className={labelClass} style={{ fontFamily: "Muli" }}>WEDDING / EVENT LOCATION *</label>
								<input className={inputClass} type="text" name="weddingLocation" value={heroFormData.weddingLocation} onChange={handleHeroInputChange} placeholder="City, Country" style={{ fontFamily: "Muli" }} required />
							</div>
						</div>
						<div className="mt-8">
							<label className={labelClass} style={{ fontFamily: "Muli" }}>TELL US ABOUT YOUR WEDDING / EVENT *</label>
							<textarea
								rows="4"
								className="focus:outline-none focus:border-black block w-full border-b border-gray-400 py-2 bg-transparent resize-none sm:text-sm"
								name="aboutWedding"
								value={heroFormData.aboutWedding}
								onChange={handleHeroInputChange}
								style={{ fontFamily: "Muli" }}
								required
								placeholder="Describe your event, theme, number of guests, and any specific requirements..."
							/>
						</div>
						<div className="mt-8">
							<label className={labelClass} style={{ fontFamily: "Muli" }}>WHY CHOOSE GLINTZ MEDIA? *</label>
							<textarea
								rows="3"
								className="focus:outline-none focus:border-black block w-full border-b border-gray-400 py-2 bg-transparent resize-none sm:text-sm"
								name="whyUs"
								value={heroFormData.whyUs}
								onChange={handleHeroInputChange}
								style={{ fontFamily: "Muli" }}
								required
								placeholder="What attracted you to our work?"
							/>
						</div>
						<div className="mt-10 flex justify-center">
							<button type="submit" className="bg-custom-dark-gray-bg px-16 py-3 tracking-[.3em] text-xs text-white uppercase hover:bg-opacity-90 transition-all" style={{ fontFamily: "Muli" }}>
								Submit Enquiry
							</button>
						</div>
					</form>
				</div>

				{/* Contact details strip */}
				<div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:px-80 px-10 pt-14 gap-6">
					{[
						{ icon: "https://img.icons8.com/glyph-neue/44/new-post.png", alt: "email", content: <a className="text-custom-gray-text" style={{ fontFamily: "Muli" }} href="mailto:temitope@glintzphotography.org">temitope@glintzphotography.org</a> },
						{ icon: "https://img.icons8.com/ios-filled/44/address--v1.png", alt: "address", content: <p className="text-custom-gray-text capitalize" style={{ fontFamily: "Muli" }}>Manchester, United Kingdom</p> },
						{ icon: "https://img.icons8.com/ios/44/phone--v1.png", alt: "phone", content: <a className="text-custom-gray-text" style={{ fontFamily: "Muli" }} href="tel:+447823683844">+44 782 368 3844</a> },
						{ icon: "https://img.icons8.com/ios/44/instagram-new--v1.png", alt: "instagram", content: <a className="text-custom-gray-text" href="https://instagram.com/glintzweddingphotography" target="_blank" rel="noreferrer" style={{ fontFamily: "Muli" }}>@glintzweddingphotography</a> },
					].map((item, i) => (
						<div key={i} className="text-center mb-5 xl:mb-0">
							<div className="flex justify-center items-center mb-2"><img width="44" height="44" src={item.icon} alt={item.alt} /></div>
							{item.content}
						</div>
					))}
				</div>
			</div>


			{/* ── SECTION 8: FAQ ACCORDION ── */}
			<div className="xl:px-40 lg:px-20 px-8 py-20 bg-white">
				<div className="text-center mb-12">
					<p className="text-xs tracking-[.35em] uppercase text-custom-gray-text mb-4" style={{ fontFamily: "Muli" }}>Common Questions</p>
					<h2 className="uppercase xl:text-4xl lg:text-3xl text-2xl tracking-[.12em] text-custom-gray-head-text mb-4">
						FAQs About Our UK Photography Services
					</h2>
					<div className="w-10 h-px bg-gray-400 mx-auto" />
				</div>
				<div className="max-w-3xl mx-auto">
					{faqs.map((faq, i) => (
						<FAQItem
							key={i}
							faq={faq}
							isOpen={openFaq === i}
							onToggle={() => setOpenFaq(openFaq === i ? null : i)}
						/>
					))}
				</div>
			</div>


			{/* ── INSTAGRAM FOLLOW ── */}
			<div className="grid grid-cols-1 text-center py-20 bg-custom-dark-gray-bg hover:opacity-90 transition">
				<h2 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl tracking-[.25em] uppercase mb-5 text-white">
					follow us on instagram
				</h2>
				<p className="mb-2 text-white italic text-xl"><a href="https://www.instagram.com/glintzweddingphotography/">@glintzweddingphotography</a></p>
				<p className="text-white italic text-xl"><a href="https://www.instagram.com/glintz_studios/">@glintz_studios</a></p>
			</div>


			{/* ── FOOTER SOCIAL / LOGO / NEWSLETTER ── */}
			<div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 py-10">
				<div className="border-r px-10 py-20">
					<h3 className="text-2xl text-center uppercase tracking-[.15em] mb-2 text-custom-gray-text font-semibold">follow us</h3>
					<div className="flex justify-center space-x-8">
						<a href="https://web.facebook.com/glintzmedia?mibextid=ZbWKwL"><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/facebook-new.png" alt="facebook" /></a>
						<a href="https://www.instagram.com/glintzweddingphotography?igsh=MTJibTkyZzhjczljeg=="><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/instagram-new.png" alt="instagram" /></a>
						<a href="https://www.instagram.com/glintz_studios"><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/instagram-new.png" alt="instagram studios" /></a>
						<a href="https://x.com/glintzmedia?t=Lhsmk9m7viwv0muKKfviiQ&s=08"><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/twitter--v1.png" alt="twitter" /></a>
						<a href="https://www.youtube.com/channel/UCMdqsviB8dCvgYGTLPBgVaQ"><img width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/youtube-play.png" alt="youtube" /></a>
					</div>
				</div>
				<div className="flex justify-center py-20 border-r">
					<img src={logo} alt="Glintz Photography Logo" className="w-[50%] md:w-[30%] sm:w-[30%] h-[100%]" />
				</div>
				<div className="px-10 py-20">
					<div className="text-center">
						<h3 className="uppercase text-2xl tracking-[.15em] font-semibold text-custom-gray-text">newsletter</h3>
						<p className="italic text-xl text-custom-gray-text">Follow our latest stories.</p>
					</div>
					<form className="text-center mt-2" onSubmit={subscribeForm}>
						<input type="text" placeholder="E-MAIL" name="email" value={subscribeData.email} onChange={handleInputChangeSubscribe} style={{ fontFamily: "Muli" }} className="tracking-[.1em] border-b px-4 text-sm" />
						<button className="border-b px-2 mt-4 uppercase" style={{ fontFamily: "Muli" }}>submit</button>
					</form>
				</div>
			</div>

			<Footer />
		</>
	)
}

export default HomePage